// Contexts
import { getConfigProperty } from '../../EnvironmentConfig/EnvironmentConfig';
// Types
import { OrganizationCodeTypes, OrganizationDetailsEnvSpecific } from '../../types/OrganizationTypes';
// Utils
import { getReferringCompany } from '../ReferringCompanyValueGetter/ReferringCompanyValueGetter';
// Constants
import {
  BASIC_AUTH_TOKEN_CD,
  BASIC_AUTH_TOKEN_CDSA,
  BASIC_AUTH_TOKEN_FCG,
  BASIC_AUTH_TOKEN_TORFX,
  BASIC_AUTH_TOKEN_TORFXOZ,
  CDSA,
  CURRENCIES_DIRECT,
  CURRENCIES_DIRECT_SA,
  FCG,
  FOREMOST_CURRENCY_GROUP,
  TORFX,
  TORFX_OZ
} from '../Constants/Constants';

interface BasicDetails {
  referringCompany: string;
  basicAuthToken: string;
  organisation: string;
  organisationCode: string;
}

const GetBasicDetails = (): BasicDetails => {
  const referringCompany: string = getReferringCompany();

  let basicAuthToken;

  const BASIC_AUTH_TOKEN_SELECTOR = {
    currenciesdirect: BASIC_AUTH_TOKEN_CD,
    currenciesdirectsa: BASIC_AUTH_TOKEN_CDSA,
    torfx: BASIC_AUTH_TOKEN_TORFX,
    torfxoz: BASIC_AUTH_TOKEN_TORFXOZ,
    fcg: BASIC_AUTH_TOKEN_FCG,
  };

  basicAuthToken = (getConfigProperty('basicAuthToken') as OrganizationDetailsEnvSpecific)[referringCompany as OrganizationCodeTypes] || BASIC_AUTH_TOKEN_SELECTOR[referringCompany];

  let organisation: string;

  const ORGANISATION_NAME_SELECTOR = {
    currenciesdirect: CURRENCIES_DIRECT,
    currenciesdirectsa: CURRENCIES_DIRECT_SA,
    torfx: TORFX,
    torfxoz: TORFX_OZ,
    fcg: FOREMOST_CURRENCY_GROUP,
  };
  organisation = ORGANISATION_NAME_SELECTOR[referringCompany];

  let organisationCode: string;

  const ORGANISATION_CODE_SELECTOR = {
    currenciesdirect: CURRENCIES_DIRECT,
    currenciesdirectsa: CDSA,
    torfx: TORFX,
    torfxoz: TORFX_OZ,
    fcg: FCG,
  };
  organisationCode = ORGANISATION_CODE_SELECTOR[referringCompany];

  return {
    referringCompany,
    basicAuthToken,
    organisation,
    organisationCode
  };
};

export default GetBasicDetails;
